import { formatMultipleSelectData } from './formatMultipleSelectData'

export const generateClubCourseSearchPayload = (
  data: CourseClubSearchForm,
  limit: number,
  offset: number,
): ClubAndCourseSearchPayload => {
  const {
    countries,
    states,
    city,
    clubId,
    clubName,
    courseId,
    courseName,
    activeClubs,
    activeCourses,
    officialCourses,
    providerId,
  } = data

  const countryIds = formatMultipleSelectData(countries).map((country) => Number(country))
  const stateIds = formatMultipleSelectData(states).map((state) => Number(state))

  return {
    data: {
      ...(countries.length > 0 && { countryIds }),
      ...(states.length > 0 && { stateIds }),
      ...(city && { city }),
      ...(clubId && { clubIds: [parseInt(clubId)] }),
      ...(courseId && { courseId: parseInt(courseId) }),
      ...(courseName && { courseName }),
      ...(clubName && { clubName }),
      ...(activeClubs && { activeClubs: activeClubs === 'true' }),
      ...(activeCourses && { activeCourses: activeCourses === 'true' }),
      ...(officialCourses && { officialCourses: officialCourses === 'true' }),
      ...(providerId !== '' && providerId !== null && { providerId: parseInt(providerId) }),
      limit,
      offset,
    },
  }
}
